import {
    ADD_PAYMENT_BEGIN,
    ADD_PAYMENT_SUCCESS,
    ADD_PAYMENT_FAILURE
} from '../constants'
import { ACTION_STATE } from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case ADD_PAYMENT_BEGIN:
            return {
                ...state,
                addPaymentState: ACTION_STATE.PENDING
            }
        case ADD_PAYMENT_SUCCESS:
            return {
                ...state,
                addPaymentState: ACTION_STATE.SUCCESS,
                urlAddPyment: action.data.urlAddPyment
            }
        case ADD_PAYMENT_FAILURE:
            return {
                ...state,
                addPaymentState: ACTION_STATE.ERROR,
                errorMessagePayment: action.data
            }
        default:
            return state
    }
}
